import { AnyAction } from '@reduxjs/toolkit'

import * as actionTypes from './actionTypes'

type ChatState = {
  isThinking: boolean
  utterance: string
  conversation: { source?: string; text: string; selected?: boolean; options?: string[] }[]
  audienceToShow: { all: boolean }
  batch?: any
  prompt?: any
}

const initialState: ChatState = {
  isThinking: false,
  utterance: '',
  conversation: [],
  audienceToShow: { all: true }
}

export default function chatReducer(state = initialState, action: AnyAction): ChatState {
  switch (action.type) {
    case actionTypes.CHAT_ADD_UTTERANCE: {
      const newConversation = state.conversation.slice()
      newConversation.push({
        source: 'user',
        text: action.utterance
      })
      return { ...state, conversation: newConversation }
    }
    case actionTypes.CHAT_RESET: {
      return { ...state, conversation: [], isThinking: false, audienceToShow: { all: true }, batch: {} }
    }
    case actionTypes.CHAT_ADD_REPLY: {
      const reply = action.reply || action.text
      const conversation = [
        ...state.conversation,
        {
          source: 'system',
          text: reply,
          suggestions: action.suggestions,
          card: action.card,
          title: action.title,
          detail: action.detail,
          url: action.url,
          image: action.image,
          feedbackRequest: action.feedbackRequest,
          // v2
          prompt: action.prompt,
          actions: action.actions
        }
      ]
      return {
        ...state,
        conversation,
        isThinking: false,
        prompt: action.prompt
      }
    }
    case actionTypes.CHAT_SYSTEM_THINKING: {
      return { ...state, isThinking: action.isThinking }
    }
    case actionTypes.CHAT_SELECT_OPTION: {
      const conversation = [...state.conversation]
      conversation[action.selectedOption.conversationIndex].selected = action.selectedOption.value
      return { ...state, conversation, isThinking: false }
    }
    case actionTypes.CHAT_ERROR: {
      const newConversation = state.conversation.slice()
      newConversation.push({
        source: 'system',
        text: 'There was an error processing your phrase.  Please try again soon.'
      })
      return {
        ...state,
        conversation: newConversation,
        isThinking: false,
        prompt: null
      }
    }
    case actionTypes.CHAT_SET_AUDIENCE: {
      return { ...state, audienceToShow: action.audienceToShow }
    }
    case actionTypes.CHAT_V2_BATCH_STATUS: {
      return {
        ...state,
        batch: { ...action.batch, batchTestInitiated: !!action.batchTestInitiated }
      }
    }
    case actionTypes.CHAT_BATCH_IN_PROGRESS: {
      return {
        ...state,
        batch: { ...action.batch, batchTestInitiated: !!action.batchTestInitiated }
      }
    }
    default: {
      return state
    }
  }
}
